import { render, staticRenderFns } from "./hire-situation.vue?vue&type=template&id=2f71abc1&scoped=true&"
import script from "./hire-situation.vue?vue&type=script&lang=js&"
export * from "./hire-situation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f71abc1",
  null
  
)

export default component.exports